import React  from "react";
import { useParams } from 'react-router-dom';
import SettingForm from "./components/SettingForm";
import Card from "components/card";

const EditEmployeeSetting = ( ) => {

	const { employeeId, settingId } = useParams();
	
	return (
	    <div>
	    	<Card extra={"w-full h-full p-4"}>
				<div className="grid h-full grid-cols-1 gap-4">
      				<SettingForm 
						employeeId={employeeId} 
						recordId={settingId} 
						mode="edit"
					/>
	      		</div>
	    	</Card>
	    </div>
    );
};

export default EditEmployeeSetting;